import { render, staticRenderFns } from "./attachmentButtonHeader.vue?vue&type=template&id=feb89674&scoped=true"
import script from "./attachmentButtonHeader.vue?vue&type=script&lang=js"
export * from "./attachmentButtonHeader.vue?vue&type=script&lang=js"
import style0 from "./attachmentButtonHeader.vue?vue&type=style&index=0&id=feb89674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb89674",
  null
  
)

export default component.exports